document.addEventListener('alpine:init', () => {
    Alpine.data('booking', () => ({
        modalOpen: false,
        checkinHourList: [],
        checkoutHourList: [],
        currentDay: moment(window.bookingApp.today).format('dddd'),
        // currentDay: moment('Sun Dec 17 2023 11:48:55 GMT+0600 (Bangladesh Standard Time)').format('dddd'),
        checkinDate: '',
        checkoutDate: '',
        checkinDay: '',
        checkoutDay: '',
        checkInTime: '',
        checkoutTime: '',
        checkinOpneing: false,
        checkoutOpening: false,
        checkin: '',
        checkout: '',
        quantity: 1,
        days: 1,
        total: 5,
        isLoading: false,
        disabledButtons: true,
        isTimeOk: true,
        init() {
          this.setInitialValues();
          this.initializeLightPicker();
          this.checkOpening(); 
          // this.checkOpening(window.bookingApp.today); // decides open/close based on stores location time.
          
          this.$watch('checkinDate', value => {
            this.setCheckinhourList(value);
            this.showDates();
          });
          
          this.$watch('checkInTime', value => {
            this.showDates();
            this.checkOpening();
            this.setCheckouthourList();
          });

          this.$watch('checkoutDate', value => {
            this.setCheckouthourList(value);
            this.showDates();
          });

          this.$watch('checkoutTime', value => {
            this.showDates();
            this.checkOpening();
          });

          this.$watch('quantity', value => {
            this.showDates();
          });

        },
        setInitialValues() {
          // set dates
          this.checkinDate = moment(window.bookingApp.today);
          this.checkoutDate = moment(window.bookingApp.today);
          
          this.setCheckinhourList();
          this.setCheckouthourList();

          this.showDates();
        },
        initializeLightPicker() {
          const self = this;
          new Lightpick({
            field: document.getElementById('demo-10'),
            secondField: document.getElementById('demo-11'),
            inline: true,
            minDate: window.bookingApp.today,
            onSelect: function(start, end) {
              self.disabledButtons = start > end;
              
              self.checkinDate = start;
              if (end) self.checkoutDate = end;
              else self.checkoutDate = start;
            }
          });
        },
        setCheckinhourList(checkinDay) {
          const currentDay = checkinDay ? moment(checkinDay).format('dddd') : moment(window.bookingApp.today).format('dddd');
          const currentDayConfig = window.bookingApp.config.days.find(d => d.day === currentDay);
          this.checkinHourList = getHourList(currentDayConfig.start, currentDayConfig.close);
          const currentTime = moment(window.bookingApp.today).format('HH:mm:ss');

          if (moment(window.bookingApp.today).isSame(this.checkinDate, 'day')) {
            const isInRange = this.isInRange(currentTime, currentDayConfig.start, currentDayConfig.close);
            console.log(currentTime, currentDayConfig.start, currentDayConfig.close)
            console.log(isInRange)
            if (isInRange) {
              const nextHour = moment(window.bookingApp.today).clone().startOf('hour').add(1, 'hour');
              this.checkInTime = nextHour.format('HH:mm:ss');

              // set checkout time
              this.checkoutTime = nextHour.clone().startOf('hour').add(1, 'hour');
            } else {
              this.checkInTime = this.checkinHourList[0];
            }
          } else {
            this.checkInTime = this.checkinHourList[0];
          }
        },
        isInRange(time, startTime, endTime) {
          var ct = moment(time, 'HH:mm:ss');

          // Assume you have the start and end times of the range
          var st = moment(startTime, 'HH:mm:ss');
          var et = moment(endTime, 'HH:mm:ss');
          
          // Check if checkTime is within the range startTime to endTime
          var isInRange = ct.isBetween(st, et);
          return isInRange;
        },
        setCheckouthourList(checkoutDay) {
          const currentDay = checkoutDay ? moment(checkoutDay).format('dddd') : moment(window.bookingApp.today).format('dddd');
          const currentDayConfig = window.bookingApp.config.days.find(d => d.day === currentDay);
          this.checkoutHourList = getHourList(currentDayConfig.start, currentDayConfig.close);

          this.checkoutTime = moment(this.checkinDate).isSame(this.checkoutDate, 'day') ? this.checkoutHourList[this.checkoutHourList.indexOf(this.checkInTime) + 1] : this.checkoutHourList[0];
        },
        showDates() {
          let checkinDayString = moment(window.bookingApp.today).isSame(this.checkinDate, 'day') ? 'Today' : moment(this.checkinDate).format('ddd, MM/DD');
          this.checkinDay = checkinDayString;
          checkinDayString += ', ' + moment(this.checkInTime, 'HH:mm:ss').format('h:mm a');
          this.checkin = checkinDayString;

          let checkoutDayString = moment(this.checkinDate).isSame(this.checkoutDate, 'day') ? 'Sameday' : moment(this.checkoutDate).format('ddd, MM/DD');
          this.checkoutDay = checkoutDayString;
          
          console.log(this.checkoutTime);
          
          checkoutDayString += ', ' + moment(this.checkoutTime, 'HH:mm:ss').format('h:mm a');
          this.checkout = checkoutDayString;

          // calculate day diff
          this.days = Math.abs(moment(this.checkinDate).diff(moment(this.checkoutDate), 'days')) + 1;

          this.total = 5 * this.days * this.quantity;

          // validate check in and checkout time
          this.isTimeOk = moment(this.checkoutTime, 'HH:mm:ss').isSameOrBefore(moment(this.checkInTime, 'HH:mm:ss'))
        },
        checkOpening(time) {
          if (time) {
            const checkinDay = this.checkinDate.format('dddd') || moment(window.bookingApp.today).format('dddd');
    
            const currentConfig = window.bookingApp.config.days.find(d => d.day === checkinDay);
            
            const current = moment(moment(time).format('HH:mm:ss'), 'HH:mm:ss');
            const start = moment(currentConfig.start, 'HH:mm:ss');
            const end = moment(currentConfig.close, 'HH:mm:ss');

            console.log(time)
            console.log(current)
            console.log(start)
            console.log(end)

            console.log(current.isSameOrAfter(start))
            console.log(current.isSameOrBefore(end))
  
            const isInRange = current.isSameOrAfter(start) && current.isSameOrBefore(end);
  
            this.checkinOpneing = isInRange;
            this.checkoutOpening = isInRange;
            
          } else  {
            const checkinDay = this.checkinDate.format('dddd');
            const checkoutDay = this.checkoutDate.format('dddd');
    
            const checkinConfig = window.bookingApp.config.days.find(d => d.day === checkinDay);
            const checkoutConfig = window.bookingApp.config.days.find(d => d.day === checkoutDay);
            
            const checkinTime = moment(this.checkInTime, 'HH:mm:ss');
            const checkoutTime = moment(this.checkoutTime, 'HH:mm:ss');
            
            const checkinStart = moment(checkinConfig.start, 'HH:mm:ss');
            const checkinEnd = moment(checkinConfig.close, 'HH:mm:ss');
            
            const checkoutStart = moment(checkoutConfig.start, 'HH:mm:ss');
            const checkoutEnd = moment(checkoutConfig.close, 'HH:mm:ss');
  
            const isInRange = checkinTime.isSameOrAfter(checkinStart) && checkinTime.isSameOrBefore(checkinEnd);
  
            this.checkinOpneing = checkinTime.isSameOrAfter(checkinStart) && checkinTime.isSameOrBefore(checkinEnd);
            this.checkoutOpening = checkoutTime.isSameOrAfter(checkoutStart) && checkinTime.isSameOrBefore(checkoutEnd);
          }
        },
        isDisabledHour(time, index, hourList, selectedTime) {
          // const checkinTimeIndex = hourList.indexOf(time);
          const selectedTimeIndex = hourList.indexOf(selectedTime);
          // console.log(index, selectedTime, selectedTimeIndex)
          return moment(this.checkinDate).isSame(this.checkoutDate, 'day') && selectedTimeIndex > index
        },
        isDisabledCheckInHour(index, hourList) {
          const currentDay = moment(window.bookingApp.today);
          const currentHour = moment(window.bookingApp.today).clone().startOf('hour').add(1, 'hour').format('HH:mm:ss');
          
          const selectedIndex = hourList.indexOf(currentHour);
          // console.log(selectedIndex, index, moment(this.checkinDate).isSame(currentDay, 'day'))
          return moment(this.checkinDate).isSame(currentDay, 'day') && selectedIndex > index;
        },
        toggle() {
          this.modalOpen = ! this.modalOpen
        },
        async getProduct() {
          return fetch(`/products/booking-product.js`).then(res => res.json());
        },
        async addToCart(e) {
          e.preventDefault();
          this.isLoading = true;
          const product = await this.getProduct();
   
          const variant = product.variants.find(v => Number(v.option1) == Number(this.days));

          const body = {
            items: [
              {
                id: variant.id,
                quantity: this.quantity,
                properties: {
                  "Check In Date": moment(this.checkinDate).format('dddd, MMM DD, YYYY'),
                  "Check In Time": moment(this.checkInTime, 'HH:mm:ss').format('hh:mm A'),
                  "Check Out Date": moment(this.checkoutDate).format('dddd, MMM DD, YYYY'),
                  "Check Out Time": moment(this.checkoutTime, 'HH:mm:ss').format('hh:mm A')
                }
              }
            ]
          }

          await fetch(`/cart/clear.js`).then(res => res.json());

          await fetch(`/cart/add.js`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
          }).then(res => {
            if (res.ok) {
              window.location.href = '/checkout';
              return;
            }
            console.error(res.json());
            this.isLoading = false;
          })
        }
    }))
});


function getHourList(startHour, endHour) {
  const hoursList = [];

  // Define the start and end times for your list of hours
  const startTime = moment(startHour, 'HH:mm:ss'); // Start at midnight
  const endTime = moment(endHour, 'HH:mm:ss');   // End at 11:00 PM

  // console.log(startTime, endTime)

  // Define the interval between each hour (e.g., 1 hour)
  const hourInterval = 1;
  
  // Loop through the hours and add them to the list
  let currentTime = startTime.clone();
  while (currentTime.isSameOrBefore(endTime)) {
    hoursList.push(currentTime.format('HH:mm:ss')); // Format the time as needed
    
    currentTime.startOf('hour').add(hourInterval, 'hours');
  }

  // console.log(hoursList);
  
  // Now, hoursList contains a list of hours in the format "HH:mm"
  return hoursList;
}